import { Fragment } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/** Jeden punkt „Na jakiej podstawie” — etykieta i opis z API (`suggestion-basis.ts`). */
export interface SuggestionBasisItem {
  label: string;
  text: string;
}

/**
 * Przycisk „Na jakiej podstawie” przy podpowiedzi — ikona z dymkiem, ten sam
 * w obu kierunkach (podpowiedź pojazdów przy zleceniu, zleceń na karcie auta).
 */
export const BasisToggle = ({
  open,
  onToggle,
  testId,
}: {
  open: boolean;
  onToggle: () => void;
  /** `data-testid` przycisku — np. z kontraktu paczki (`ftl-zlecenie-uzasadnienie`, S-22.10-02). */
  testId?: string;
}) => (
  <Tooltip title={open ? 'Zwiń podstawy' : 'Na jakiej podstawie'}>
    <IconButton
      size="small"
      aria-label={open ? 'Zwiń podstawy' : 'Na jakiej podstawie'}
      aria-expanded={open}
      color={open ? 'primary' : 'default'}
      onClick={onToggle}
      data-testid={testId}
    >
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

/**
 * Uzasadnienie punkt po punkcie (FTL V2.1 §10, I.02) — lista opisowa pod
 * wierszem podpowiedzi. Tylko pokazuje, co przyszło z API; nic nie liczy.
 */
export const BasisList = ({ title, basis }: { title: string; basis: SuggestionBasisItem[] }) => (
  <>
    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
      {title}
    </Typography>
    <Box
      component="dl"
      sx={{
        m: 0,
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        columnGap: 2,
        rowGap: 0.5,
      }}
    >
      {basis.map((b) => (
        <Fragment key={b.label}>
          <Typography component="dt" variant="body2" sx={{ fontWeight: 600 }}>
            {b.label}
          </Typography>
          <Typography component="dd" variant="body2" sx={{ m: 0 }}>
            {b.text}
          </Typography>
        </Fragment>
      ))}
    </Box>
  </>
);
